import { render } from "./materialManager.vue?vue&type=template&id=17621293"
import script from "./materialManager.vue?vue&type=script&lang=js"
export * from "./materialManager.vue?vue&type=script&lang=js"

import "./materialManager.vue?vue&type=style&index=0&id=17621293&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__